import { useLocation } from "react-router-dom";
import { DeepLinker } from "./deeplinker";
import { os, url, fallbackToStorePaths, analytics } from "./config/constants";
import "./App.css";
import { useEffect } from "react";
import { useSegmentTrack } from "react-segment-analytics";
import { extractTrackingParameter } from "./utils/analyticsHelper";

const checkOS = () => {
  const userAgent = navigator.userAgent;
  if (/android/i.test(userAgent)) {
    return os.android;
  }
  if (/iPad|iPhone|iPod/i.test(userAgent)) {
    return os.ios;
  }
};

function App() {
  const location = useLocation();
  const track = useSegmentTrack();

  const hostName = process.env.REACT_APP_REDIRECT_URL_HOST_NAME;
  const deeplinkScheme = process.env.REACT_APP_DEEPLINK_SCHEME;

  const deeplinkUrl = `${deeplinkScheme}://${hostName}${location.pathname}${location.search}`;
  const defaultRedirectUrl = `https://${hostName}${location.pathname}${location.search}`;

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    let redirectUrl = defaultRedirectUrl;

    if (location.pathname === "/affiliate-program") {
      redirectUrl = "affiliate"
    }

    if (
      fallbackToStorePaths.filter((path) => location.pathname.includes(path))
        .length > 0 ||
      query.get("fallback") === "store"
    ) {
      if (checkOS() === os.ios) {
        redirectUrl = url.appStoreUrl;
      } else if (checkOS() === os.android) {
        redirectUrl = url.playStoreUrl;
      }
    }

    var linker = new DeepLinker({
      onIgnored: function () {
        window.location = redirectUrl;
      },
      onFallback: function () {
        window.location = redirectUrl;
      },
      onReturn: function () {},
    });

    linker.openURL(deeplinkUrl);
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <p>Redirecting to NocNoc</p>
        <a
          className="App-link"
          href={defaultRedirectUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          If site is not redirect, click here
        </a>
      </header>
    </div>
  );
}

export default App;
